import { Reducer } from 'redux';
import { FacialTypes, FacialState } from './types';

export const INITIAL_STATE: FacialState = {
  facialList: [],
  lastValidationFacialList: [],
  facialSettingsData: {
    id: '',
    blockCount: 0,
    blockTime: 0,
    sendReports: 0,
    blockPercentage: 0,
    sendReportEmails: '',
    createdAt: '',
    updatedAt: '',
    transportOperatorId: '',
  },
  userStatus: {
    correct: 0,
    suspicous: 0,
  },
  currentCard: 1,
  scorePercent: '',
  selectedStatus: [],
  selectedApprovalStatus: [],
  chipsList: [],
  uploadStatusList: [],
  facialDailyResumeList: [],
  facialDayDetailList: [],
  selectedStartDate: new Date(),
  selectedEndDate: new Date(),
  selectedValidationStatus: [],
  totalCount: 0,
  error: false,
  statusLoading: false,
  loading: false,
  loadingStatus: false,
  lastValidationLoading: false,
};

const reducer: Reducer<FacialState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST FACIAL RECOGNITION
    case FacialTypes.LIST_FACIAL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        facialList: INITIAL_STATE.facialList,
      };

    case FacialTypes.LIST_FACIAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        facialList: action.payload.facialList,
        totalCount: action.payload.totalCount,
      };

    case FacialTypes.LIST_FACIAL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        facialList: INITIAL_STATE.facialList,
      };

    // CASE LAST_VALIDATION_LIST_FACIAL
    case FacialTypes.LAST_VALIDATION_LIST_FACIAL_REQUEST:
      return {
        ...state,
        lastValidationLoading: true,
        error: false,
        lastValidationFacialList: INITIAL_STATE.lastValidationFacialList,
      };
    case FacialTypes.LAST_VALIDATION_LIST_FACIAL_SUCCESS:
      return {
        ...state,
        lastValidationLoading: false,
        error: false,
        lastValidationFacialList: action.payload.lastValidationFacialList,
      };

    case FacialTypes.LAST_VALIDATION_LIST_FACIAL_FAILURE:
      return {
        ...state,
        lastValidationLoading: false,
        error: true,
        lastValidationFacialList: INITIAL_STATE.lastValidationFacialList,
      };

    // CASES GET SETTINGS
    case FacialTypes.GET_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        facialSettingsData: INITIAL_STATE.facialSettingsData,
      };

    case FacialTypes.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        facialSettingsData: action.payload.facialSettingsData,
      };

    case FacialTypes.GET_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        facialSettingsData: INITIAL_STATE.facialSettingsData,
      };

    // CASES LIST FACIAL_DAILY_RESUME
    case FacialTypes.LIST_FACIAL_DAILY_RESUME_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        facialDailyResumeList: INITIAL_STATE.facialDailyResumeList,
      };

    case FacialTypes.LIST_FACIAL_DAILY_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        facialDailyResumeList: action.payload.facialDailyResumeList,
        totalCount: action.payload.totalCount,
      };

    case FacialTypes.LIST_FACIAL_DAILY_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        facialDailyResumeList: INITIAL_STATE.facialDailyResumeList,
      };

    // CASES LIST FACIAL_DAY_DETAIL
    case FacialTypes.LIST_FACIAL_DAY_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        facialDayDetailList: INITIAL_STATE.facialDayDetailList,
      };

    case FacialTypes.LIST_FACIAL_DAY_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        facialDayDetailList: action.payload.facialDayDetailList,
        totalCount: action.payload.totalCount,
      };

    case FacialTypes.LIST_FACIAL_DAY_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        facialDayDetailList: INITIAL_STATE.facialDayDetailList,
      };

    // CASES GET UPLOAD STATUS
    case FacialTypes.GET_UPLOAD_STATUS_REQUEST:
      return {
        ...state,
        loadingStatus: true,
        error: false,
        uploadStatusList: INITIAL_STATE.uploadStatusList,
      };

    case FacialTypes.GET_UPLOAD_STATUS_SUCCESS:
      return {
        ...state,
        loadingStatus: false,
        error: false,
        uploadStatusList: action.payload.uploadStatusList,
      };

    case FacialTypes.GET_UPLOAD_STATUS_FAILURE:
      return {
        ...state,
        loadingStatus: false,
        error: true,
        uploadStatusList: INITIAL_STATE.uploadStatusList,
      };

    // CASES UPDATE SETTINGS
    case FacialTypes.UPDATE_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        facialSettingsData: INITIAL_STATE.facialSettingsData,
      };

    case FacialTypes.UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        facialSettingsData: action.payload.facialSettingsData,
      };

    case FacialTypes.UPDATE_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        facialSettingsData: INITIAL_STATE.facialSettingsData,
      };

    // CASES GET USER STATUS
    case FacialTypes.GET_USER_STATUS_REQUEST:
      return {
        ...state,
        statusLoading: true,
        loadingStatus: true,
        error: false,
        userStatus: INITIAL_STATE.userStatus,
      };

    case FacialTypes.GET_USER_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        loadingStatus: false,
        error: false,
        userStatus: action.payload.userStatus,
      };

    case FacialTypes.GET_USER_STATUS_FAILURE:
      return {
        ...state,
        statusLoading: false,
        loadingStatus: false,
        error: true,
        userStatus: INITIAL_STATE.userStatus,
      };

    // CASES CURRENT CARD
    case FacialTypes.CURRENT_CARD:
      return {
        ...state,
        error: false,
        currentCard: action.payload.cardIndex,
      };

    // SET SELECTED SCORE
    case FacialTypes.SET_SELECTED_SCORE:
      return {
        ...state,
        error: false,
        scorePercent: action.payload.scorePercent,
      };

    // SET SELECTED STATUS
    case FacialTypes.SET_SELECTED_STATUS:
      return {
        ...state,
        error: false,
        selectedStatus: action.payload.selectedStatus,
      };

    // SET SELECTED APPROVAL STATUS
    case FacialTypes.SET_SELECTED_APPROVAL_STATUS:
      return {
        ...state,
        error: false,
        selectedApprovalStatus: action.payload.selectedApprovalStatus,
      };

    // CASES GET CHIPS
    case FacialTypes.CREATE_CHIPS_LIST:
      return {
        ...state,
        error: false,
        chipsList: action.payload.chipsList,
      };

    // CASES CLEAR CHIPS
    case FacialTypes.CLEAN_CHIPS_LIST:
      return {
        ...state,
        error: false,
        chipsList: INITIAL_STATE.chipsList,
      };

    // SET SELECTED START DATE
    case FacialTypes.SET_SELECTED_START_DATE:
      return {
        ...state,
        error: false,
        selectedStartDate: action.payload.selectedStartDate,
      };

    // CASES SELECTED END DATE
    case FacialTypes.SET_SELECTED_END_DATE:
      return {
        ...state,
        error: false,
        selectedEndDate: action.payload.selectedEndDate,
      };

    // SET SELECTED VALIDATION STATUS
    case FacialTypes.SET_SELECTED_VALIDATION_STATUS:
      return {
        ...state,
        error: false,
        selectedValidationStatus: action.payload.selectedValidationStatus,
      };

    default:
      return state;
  }
};

export default reducer;
